import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FaCheckCircle, FaHandshake, FaPhone, FaEnvelope, FaMapMarkerAlt, FaArrowRight } from 'react-icons/fa';
import './ThankYou.css';

export default function ThankYou() {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check if user came from form submission
    const fromFormSubmission = location.state?.fromFormSubmission;
    
    if (!fromFormSubmission) {
      // If user didn't come from form submission, redirect to franchise page
      navigate('/franchise', { replace: true });
      return;
    }

    // Clear the state to prevent back navigation
    window.history.replaceState(null, '', '/franchise/thank-you');
    
    // Trigger animation after component mounts
    setTimeout(() => setIsVisible(true), 100);

    // Prevent back navigation
    const handlePopState = (event) => {
      navigate('/franchise', { replace: true });
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate, location.state]);

  return (
    <div className="thankyou-page">
      {/* Animated Background */}
      <div className="thankyou-bg">
        <div className="floating-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
          <div className="shape shape-4"></div>
        </div>
      </div>

      <div className={`thankyou-container ${isVisible ? 'visible' : ''}`}>
        {/* Success Icon */}
        <div className="success-icon-wrapper">
          <FaCheckCircle className="success-icon" />
          <div className="success-pulse"></div>
        </div>

        {/* Main Content */}
        <div className="thankyou-content">
          <h1 className="thankyou-title">
            Thank You for Your Interest!
          </h1>
          
          <p className="thankyou-subtitle">
            Your franchise application has been successfully submitted.
          </p>

          <div className="thankyou-message">
            <p>
              We're excited about the possibility of partnering with you to bring 
              <strong> NeatnClean's premium laundry services</strong> to your city.
            </p>
            <p>
              Our franchise team will review your application and get back to you 
              <strong> within 24 hours</strong> with the next steps.
            </p>
          </div>

          {/* What Happens Next */}
          <div className="next-steps">
            <h3><FaHandshake className="inline-icon" /> What Happens Next?</h3>
            <div className="steps-grid">
              <div className="step-item">
                <div className="step-number">1</div>
                <div className="step-content">
                  <h4>Application Review</h4>
                  <p>Our team reviews your application and location details</p>
                </div>
              </div>
              <div className="step-item">
                <div className="step-number">2</div>
                <div className="step-content">
                  <h4>Initial Discussion</h4>
                  <p>We'll call you to discuss investment details and requirements</p>
                </div>
              </div>
              <div className="step-item">
                <div className="step-number">3</div>
                <div className="step-content">
                  <h4>Site Visit & Agreement</h4>
                  <p>Location assessment and franchise agreement finalization</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Information */}
          <div className="contact-info">
            <h3>Need Immediate Assistance?</h3>
            <div className="contact-grid">
              <div className="contact-item">
                <FaPhone className="contact-icon" />
                <div>
                  <strong>Call Us</strong>
                  <p>+91 8448717900</p>
                </div>
              </div>
              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <div>
                  <strong>Email Us</strong>
                  <p>support@neatnclean.in</p>
                </div>
              </div>
              <div className="contact-item">
                <FaMapMarkerAlt className="contact-icon" />
                <div>
                  <strong>Visit Us</strong>
                  <p>B-10, Ground Floor G-02, Sector-2, Noida, UP</p>
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="thankyou-actions">
            <Link to="/" className="btn-primary">
              <FaArrowRight className="btn-icon" />
              Back to Home
            </Link>
            <Link to="/about" className="btn-secondary">
              Learn More About Us
            </Link>
          </div>

          {/* Additional Info */}
          <div className="additional-info">
            <div className="info-card">
              <h4>🚀 Quick Setup</h4>
              <p>Get your franchise up and running in just 30-45 days</p>
            </div>
            <div className="info-card">
              <h4>💰 High ROI</h4>
              <p>Attractive returns within 12-18 months</p>
            </div>
            <div className="info-card">
              <h4>🎯 Full Support</h4>
              <p>Complete training and ongoing business support</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
